var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"justify-center"},[_c('v-btn',{attrs:{"icon":"","to":{name:'forum-topic',params:{slug:_vm.slug}}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-message")]),_vm._v(_vm._s(_vm.answerCount))],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }